import { useEffect } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _DOCFileRecordDocument } from "../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../theme/Component/usePaginator";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface FileRecordDocumentsSidebarProps {
    fileRecordId: number;
    selectedFileRecordDocumentId: number | null;
    onSelectFileRecordDocument: (
        fileRecordDocumentId: number | null,
        repositoryName?: string,
        fileRecordDocument?: Record<string, any> | null,
    ) => void;
}

export const FileRecordDocumentsSidebar = ({
    fileRecordId,
    selectedFileRecordDocumentId,
    onSelectFileRecordDocument,
}: FileRecordDocumentsSidebarProps) => {
    const { instance, setLista, lista } = useDataBean(_DOCFileRecordDocument);
    const paginadorRecordDocument = usePaginator();

    useEffect(() => {
        if (!fileRecordId) {
            setLista([]);
            onSelectFileRecordDocument(null);
            return;
        }

        getFileRecordDocument(fileRecordId);
    }, [fileRecordId, paginadorRecordDocument.page]);

    const getFileRecordDocument = (idDOCFileRecord: number) => {
        instance.getDOCFileRecordDocumentRender(null, null, { IDDOCFileRecord: idDOCFileRecord }).then(
            (resp) => {
                paginadorRecordDocument.setPages(resp.NumberOfPages ?? 1);
                paginadorRecordDocument.setRecords((resp.NumberOfPages ?? 1) * 15);
                paginadorRecordDocument.setRegiPerPage(15);
                setLista(resp.List ?? []);
                onSelectFileRecordDocument(null);
            }
        ).catch(err => {
            setLista([]);
            onSelectFileRecordDocument(null);
            toast.error(err);
        });
    };

    const selectRecordDocument = (recordDocument: Record<string, any>, recordDocumentId: number, repositoryName: string) => {
        onSelectFileRecordDocument(recordDocumentId, repositoryName, recordDocument);
    };

    return (
        <aside className="file-record-documents-sidebar">
            <nav className="file-record-documents-sidebar__nav" aria-label="Documentos del expediente">
                <div className="file-record-documents-sidebar__section">Repositorio</div>

                {lista.map((recordDocument: any) => {
                    const data = recordDocument.DataBeanProperties ?? recordDocument;
                    const idDOCFileRecordDocument = Number(data.IDDOCFileRecordDocument ?? 0);
                    const name = data.DocumentTypeName ?? data.TRDName ?? `Documento ${idDOCFileRecordDocument}`;
                    const meta = [data.TRDName, data.MimeTypes].filter(Boolean).join(" - ");

                    return (
                        <button
                            type="button"
                            key={idDOCFileRecordDocument}
                            className={`file-record-documents-sidebar__item ${selectedFileRecordDocumentId === idDOCFileRecordDocument ? "is-active" : ""}`}
                            onClick={() => selectRecordDocument(recordDocument, idDOCFileRecordDocument, name)}
                            title={name}
                        >
                            <i className="ri-folder-line"></i>
                            <span className="file-record-documents-sidebar__label">
                                <span>{name}</span>
                                <small>{meta}</small>
                            </span>
                        </button>
                    );
                })}

                {lista.length === 0 &&
                    <div className="file-record-documents-sidebar__empty">
                        No hay documentos para mostrar.
                    </div>
                }
            </nav>
        </aside>
    );
};
